  //  const config = {
  //    url: "http://localhost:3333/api/v1",
  // };

 const config = {
   url: "https://api.brainbox.sbs/api/v1",
 };


export default config;
